export const NOTIFICATION_CONSTANTS = {
  NEW_NOTIFICATION: "NEW_NOTIFICATION",
  ADD_NEW_NOTIFICATION: "ADD_NEW_NOTIFICATION",
  INCREASE_NOTIFICATION_COUNT: "INCREASE_NOTIFICATION_COUNT",
  DECREASE_NOTIFICATION_COUNT: "DECREASE_NOTIFICATION_COUNT",
  SET_NOTIFICATION_COUNT: "SET_NOTIFICATION_COUNT",
  SET_NOTIFICATION: "SET_NOTIFICATION",
  READ_NOTIFICATION: "READ_NOTIFICATION",
  READ_ALL_NOTIFICATION: "READ_ALL_NOTIFICATION",

  CHANGE_NOTIFICATION_TAB:"CHANGE_NOTIFICATION_TAB"
};

export const NOTIFICATION_SOURCES = {
  SHIPMENT_ACTION: "ShipmentAction"
};
